<template>
  <div>
    <el-rate
      v-model="val"
      :disabled="disabled"
      :colors="colors">
    </el-rate>
  </div>
</template>

<script>
    export default {
        name: "index",
        data() {
            return {
                colors: { 2: '#FF7457', 4: { value: '#FFD048', excluded: true }, 5: '#67C23A' }
            }
        },
        props:{
            disabled:{
                type:Boolean,
                default:true
            },
            val:{
                type:Number,
                default: 5
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UI/AlRate/index.vue